import React from "react";

export default function Footer() {
    return <h5>This project was created by Sanelisiwe Ngubane and is <a href="https://github.com/SANEH69/weather-react">open-sourced</a>.</h5>
}